<div class="support-chat--wrapper">
  <div class="">
    <div class="row m-1" style="height: 100vh;">
      <div class="col-md-6 border-right p-0">
        <div class="support-chat--middle" *ngIf="active_chat; else noChatFound">
          <div class="container chatbot-popup" (mouseenter)="msgRead()">
            <div class="header pt-2 px-3">
              <div class="d-flex justify-content-between header-top">
                <p class="mb-0 p-head">Chat Support</p>
              </div>
            </div>
            <hr />

            <ng-container>
              <div class="main_chat">
                <div class="chat-list-header pt-2 px-3">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center gap-2">
                      <ng-container>
                        <p class="username mb-0 pt-0">
                          {{
                          active_chat.name
                          ? active_chat.name
                          : "Recuvery User"
                          }}
                        </p>
                        <div class="chat-list-user-status" *ngIf="userUpdatedStatus; else userAway">
                          <div [ngClass]="userUpdatedStatus"></div>
                          {{ userUpdatedStatus }}
                        </div>
                        <ng-template #userAway>
                          <div class="user-status">
                            <div class="unavailable"></div>
                            NA
                          </div>
                        </ng-template>
                      </ng-container>
                    </div>

                    <div class="d-flex align-items-center gap-3">
                      <button class="mr-1 my-1 btn-danger btnClose" mat-raised-button color="primary" (click)="
                          updateTicket.show(); update_status = 'resolved'
                        " pTooltip="Close Ticket" tooltipPosition="top" tooltipPosition="top"
                        *ngIf="ticket_status != 2 && !hideFieldsForOthers && this.ticket_id">
                        End Chat
                      </button>

                      <button class="m-1 btn btn-success"
                        *ngIf="showAssignModel == true && active_chat.first_assigned_id == 0 && active_chat.assigned_id == 0"
                        (click)="assignToMeModal.show()">Assign to Me</button>

                      <button class="mr-1 my-1 btn btn-success" (click)="adminGroupChatDataModal.show();"
                        *ngIf="adminGroupChatData.length > 0">
                        Show Details
                      </button>
                      <!-- *ngIf="!service.routerAuth.restricted_buttons.export" -->
                      <div class="dropdown mr-1" >
                        <button class="menu-button" type="button" ld="dropdownMenuButton1" data-bs-toggle="dropdown"
                          aria-expanded="false">
                          ⋮
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                          <li>
                            <button class="btn" (click)="export_chat()">
                              <img src="../../../../assets/images/chatbot/export_img.png" class="mx-1" />Export Chat
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <p class="right fs-14 fw-400 pb-3" *ngIf="active_chat?.admin_name">
                    This ticket is assigned to- {{ active_chat?.admin_name }}
                  </p>
                </div>
                <div class="chat-list-input_msg" *ngIf="(ticket_status != 2 || enableChat) && !disableInput"
                  [ngClass]="disableInput ? 'disable_input' : ''">
                  <div class="row input-message-container p-0 w-100">
                    <div class="col-12">
                      <div class="input-area form-group" *ngIf="file && !file.path">
                        <textarea #textareaFocused id="msgBox" (keydown)="sendMessage($event)"
                          (ngModelChange)="msgTyping()" [(ngModel)]="chat_message" aria-describedby="basic-addon2"
                          aria-label="Recipient's username" class="form-control reply-input"
                          placeholder="Type something..."></textarea>

                        <div class="input-actions">
                          <input type="file" class="type_file" title="" #uploadAttachment
                            (change)="fileSelection($event)" />
                          <i class="fa fa-paperclip" aria-hidden="true" (click)="fileSelectionAlert($event)"></i>
                          <img class="send_msg" src="assets/images/chatbot/send_msg.png" alt="" (click)="sendMessage($event)" />
                        </div>
                      </div>
                      <div class="attachment-preview-data p-2" *ngIf="file && file.path">
                        <textarea #textareaFocused (keydown.enter)="sendMessage($event)" [(ngModel)]="chat_message"
                          aria-describedby="basic-addon2" aria-label="Recipient's username"
                          class="form-control reply-input" placeholder="Type something..."></textarea>
                        <div class="attachment-preview">
                          <ng-container *ngIf="
                              file.image_type == 'png' ||
                                file.image_type == 'jpg' ||
                                file.image_type == 'jpeg';
                              else noImg
                            ">
                            <img class="preview-img object-fit-contain" [src]="file['path']" [title]="file['name']"
                              alt="{{ file['name'] }}" height="auto" width="auto" />
                          </ng-container>
                          <ng-template #noImg>
                            <ng-container *ngIf="
                                file.image_type == 'mp4' ||
                                  file.image_type == 'MOV' ||
                                  file.image_type == 'AVI';
                                else noVideo
                              ">
                            </ng-container>
                            <ng-template #noVideo>
                              <ng-container *ngIf="file.image_type == 'pdf'; else noPDF">
                                <img class="preview-img" src="assets/images/chatbot/file-icons/pdf-file-icon.svg"
                                  [title]="file['name']" alt="{{ file['name'] }}" height="auto" width="auto" />
                              </ng-container>
                              <ng-template #noPDF> </ng-template>
                            </ng-template>
                          </ng-template>
                          <i class="prac icon-reject" (click)="file = {}"></i>
                        </div>
                        <div class="input-actions">
                          <input type="file" class="type_file" title="" #uploadAttachment
                            (change)="fileSelection($event)" />
                          <i class="fa fa-paperclip" aria-hidden="true" (click)="fileSelectionAlert($event)"></i>
                          <img class="send_msg" src="assets/images/chatbot/send_msg.png" alt="" (click)="sendMessage($event)" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="chat-window chat-supp p-0 col-12 justify-content-end align-items-end">
                  <div class="col-12 mesgs p-0">
                    <div class="msg_history" #scrollMe (scroll)="onScroll($event)" [ngStyle]="{
                        height:
                          (ticket_status != 2 || enableChat) && !disableInput
                            ? 'calc(100vh - 210px)'
                            : 'calc(100vh - 110px)'
                      }">
                      <ng-container *ngIf="messages && messages.length; else noChats">
                        <ng-container *ngFor="let message of messages">
                          <div *ngIf="message.type === 'incoming_draft'"
                            class="d-flex p-0 mr-2 ml-2 mt-3 mb-3 incoming_draft_msg">
                            <div class="incoming_msg_img p-0 pr-2 text-center">
                              <p [title]="
                                  message.user_full_name ||
                                  message.from_email ||
                                  message.fromEmail
                                " class="user-name">
                                {{ getInitials(message.user_name) }}
                              </p>
                            </div>
                            <div class="received_msg ticket-msg p-0">
                              <div class="col-12 p-0 received_withd_msg ticket-msg">
                                <div class="col-12 p-0" *ngIf="
                                    message.message ||
                                    message.text ||
                                    message.html
                                  ">
                                  <p [innerHTML]="
                                      message.message ||
                                      message.text ||
                                      message.html
                                    "></p>
                                  <div class="typing-animation" [ngStyle]="{
                                      display: animationElm ? 'block' : 'none'
                                    }">
                                    <span class="typing-animation--dot"></span>
                                    <span class="typing-animation--dot"></span>
                                    <span class="typing-animation--dot"></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="divider" *ngIf="
                              message.type === 'unread_msg' && show_unread_msg
                            ">
                            <span class="line"></span>
                            <span class="text">{{ message.count }} unread</span>
                            <span class="line"></span>
                          </div>

                          <div class="d-flex" style="gap:8px"
                            *ngIf="message.other_admin_message && message.type === 'incoming'">
                            <img class="sup-image image-wrap" [src]="message.admin_image"
                              *ngIf="message.other_admin_message">
                            <div class="">
                              <span class="fw-600 fs-13" style="color:#6A6A6A;">
                                {{message.other_admin_message}}</span>
                            </div>
                          </div>

                          <div *ngIf="message.type === 'incoming'" class="p-0 mr-2 ml-2 mb-3 incoming_msg"
                            [ngClass]="message.other_admin_message ? 'incoming_msg_dynamic_msg' : ''">
                            <div class="d-flex other_admin_message align-items-center gap-3">
                              <div class="incoming_msg_img p-0 pr-2 text-center" *ngIf="!message.other_admin_message">
                                <p [title]="
                                    message.user_full_name ||
                                    message.from_email ||
                                    message.fromEmail
                                  " class="user-name">
                                  {{ getInitials(message.user_name) }}
                                </p>
                              </div>

                              <div class="d-grid" *ngIf="!message.other_admin_message">
                                <span style="font-weight: 600; color:#6A6A6A; font-size: 12px;">
                                  {{message.user_name}} (Recuvery Customer)</span>
                              </div>
                            </div>

                            <div class="received_msg ticket-msg p-0"
                              [ngClass]="!message.other_admin_message ? 'incoming_msg_dynamic_msg2' : ''">
                              <div class="col-12 p-0 received_withd_msg ticket-msg">
                                <div class="col-12 p-0" *ngIf="
                                    message &&
                                    (message.message ||
                                      message.text ||
                                      message.html) 
                                      ">
                                  <p [innerHTML]="
                                      message.text || message.message
                                    "></p>
                                </div>
                                <div class="d-flex flex-wrap w-100 ml-1" *ngIf="
                                    message.attachments &&
                                    message.attachments.length > 0
                                  ">
                                  <ng-container *ngFor="
                                      let attachment of message.attachments
                                    ">
                                    <ng-container *ngIf="
                                        attachment.file_type == 'png' ||
                                          attachment.file_type == 'jpg' ||
                                          attachment.file_type == 'jpeg';
                                        else u_noImg
                                      ">
                                      <div class="attachment-data image email p-0 mt-2 mr-2">
                                        <img (click)="imagePreview(attachment)" class="attachment"
                                          [src]="attachment['file_url']" [title]="attachment['file_name']"
                                          alt="{{ attachment['file_name'] }}" height="auto" width="auto" />
                                      </div>
                                    </ng-container>
                                    <ng-template #u_noImg>
                                      <ng-container *ngIf="
                                          attachment.file_type == 'mp4' ||
                                            attachment.file_type == 'MOV' ||
                                            attachment.file_type == 'AVI';
                                          else u_noVideo
                                        ">
                                        <div class="attachment-data video email p-0 mt-2 mr-2"></div>
                                      </ng-container>
                                      <ng-template #u_noVideo>
                                        <ng-container *ngIf="
                                            attachment.file_type == 'pdf';
                                            else u_pdf
                                          ">
                                          <div class="attachment-data pdf email p-0 mt-2 mr-2">
                                            <img class="attachment" src="assets/images/chatbot/file-icons/pdf-file-icon.svg"
                                              [title]="attachment['file_name']" alt="{{
                                                attachment['file_name']
                                              }}" height="auto" width="auto" (click)="openPdf(attachment)" />
                                          </div>
                                        </ng-container>
                                        <ng-template #u_pdf>
                                          <ng-template #u_txt>
                                            <div *ngIf="attachment.file_type"
                                              class="attachment-data text email p-0 mt-2 mr-2">
                                              <img class="attachment"
                                                src="https://practinalivecdn.s3.us-west-2.amazonaws.com/assets/images/chat-icons/file.png"
                                                [title]="
                                                  attachment['file_name']
                                                " alt="{{
                                                  attachment['file_name']
                                                }}" height="auto" width="auto" />
                                            </div>
                                          </ng-template>
                                        </ng-template>
                                      </ng-template>
                                    </ng-template>
                                  </ng-container>
                                </div>
                                <span *ngIf="message" class="time_date col-12">
                                  {{
                                  message?.created
                                  | date
                                  : "MM-dd-yy, hh:mm a"
                                  : timezone
                                  }}</span>
                              </div>
                            </div>
                          </div>

                          <div *ngIf="message.type === 'outgoing'" class="d-flex justify-content-end my-3 pr-2">
                            <div class="sent_msg ticket-msg p-0 pr-2 pl-4">
                              <div class="col-12 p-0">
                                <div class="col-12" *ngIf="message.html || message.text">
                                  <p [innerHTML]="message.html || message.text" [ngClass]="
                                      message.message_type == 'ticket_closed'
                                        ? 'ticket_closed'
                                        : ''
                                    "></p>
                                </div>
                                <div class="d-flex flex-wrap w-100 ml-1 justify-content-end" *ngIf="
                                    message.attachments &&
                                    message.attachments.length > 0
                                  ">
                                  <ng-container *ngFor="
                                      let attachment of message.attachments
                                    ">
                                    <ng-container *ngIf="
                                        attachment.file_type == 'png' ||
                                          attachment.file_type == 'jpg' ||
                                          attachment.file_type == 'jpeg';
                                        else a_noImg
                                      ">
                                      <div class="attachment-data image email p-0 mt-2 mr-2">
                                        <img (click)="imagePreview(attachment)" class="attachment"
                                          [src]="attachment['file_url']" [title]="attachment['file_name']"
                                          alt="{{ attachment['file_name'] }}" height="auto" width="auto" />
                                      </div>
                                    </ng-container>
                                    <ng-template #a_noImg>
                                      <ng-container *ngIf="
                                          attachment.file_type == 'mp4' ||
                                            attachment.file_type == 'MOV' ||
                                            attachment.file_type == 'AVI';
                                          else a_noVideo
                                        ">
                                        <div class="attachment-data video email p-0 mt-2 mr-2"></div>
                                      </ng-container>
                                      <ng-template #a_noVideo>
                                        <ng-container *ngIf="
                                            attachment.file_type == 'pdf';
                                            else a_pdf
                                          ">
                                          <div class="attachment-data pdf email p-0 mt-2 mr-2">
                                            <img class="attachment" src="assets/images/chatbot/file-icons/pdf-file-icon.svg"
                                              [title]="attachment['file_name']" alt="{{
                                                attachment['file_name']
                                              }}" height="auto" width="auto" (click)="openSubPdf(attachment)" />
                                          </div>
                                        </ng-container>
                                        <ng-template #a_pdf>
                                          <ng-template #a_txt>
                                            <div *ngIf="attachment.file_type"
                                              class="attachment-data text email p-0 mt-2 mr-2">
                                              <img class="attachment"
                                                src="https://practinalivecdn.s3.us-west-2.amazonaws.com/assets/images/chat-icons/file.png"
                                                [title]="
                                                  attachment['file_name']
                                                " alt="{{
                                                  attachment['file_name']
                                                }}" height="auto" width="auto" />
                                            </div>
                                          </ng-template>
                                        </ng-template>
                                      </ng-template>
                                    </ng-template>
                                  </ng-container>
                                </div>

                                <div class="d-flex justify-content-center">
                                  <span *ngIf="
                                      message
                                    " class="time_date col-12">
                                    {{
                                    message.created
                                    | date : "MM-dd-yy, hh:mm a" : timezone
                                    }}

                                    <img class="msg-check" [ngClass]="
                                        message.readClass == 1 ? 'read' : ''
                                      " src="assets/images/chatbot/check.svg" alt="Check Icon" />
                                    <i class="fa fa-info mt-1 info-tooltip mx-2" *ngIf="
                                        message.readClass == 1 &&
                                        message.message_seen_at
                                      " tooltip="Read at- {{
                                        message.message_seen_at
                                          | date
                                            : 'MM-dd-yy, hh:mm a'
                                            : timezone
                                      }}"></i>
                                  </span>

                                  <span class="message_progress col-12" *ngIf="
                                      message.hasOwnProperty('show_progress') &&
                                      message['show_progress']
                                    ">Sending...</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div *ngIf="
                              message.type !== 'outgoing' &&
                              message.type !== 'incoming' &&
                              message.type !== 'unread_msg'
                            " class="row status_messages text-center mt-3 mb-3">
                            <div class="col-12 message_details">
                              <ng-container *ngIf="
                                  message.message_type === 'admin_reassigned'
                                ">
                                <ng-container *ngIf="message.updated_by; else noAdmin">
                                  <p *ngIf="
                                      message.modified_by ==
                                        adminData.admin_id &&
                                      message.modified_by == message.admin_id
                                    ">
                                    You assigned the ticket to yourself
                                  </p>
                                  <p *ngIf="
                                      message.modified_by !=
                                        adminData.admin_id &&
                                      message.modified_by == message.admin_id
                                    ">
                                    {{ message.updated_by }} assigned the ticket
                                    to himself
                                  </p>
                                  <p *ngIf="
                                      message.modified_by ==
                                        adminData.admin_id &&
                                      message.modified_by != message.admin_id
                                    ">
                                    You assigned the ticket to
                                    {{ message.admin_name }}.
                                  </p>
                                  <p *ngIf="
                                      message.modified_by !=
                                        adminData.admin_id &&
                                      message.modified_by != message.admin_id
                                    ">
                                    {{ message.updated_by }} assigned the ticket
                                    to {{ message.admin_name }}
                                  </p>
                                </ng-container>
                                <ng-template #noAdmin>
                                  <p>
                                    Ticket assigned to {{ message.admin_name }}.
                                  </p>
                                </ng-template>
                              </ng-container>
                              <span [title]="message.created" class="time_date">
                                {{
                                message.created
                                | date : "MM-dd-yy, hh:mm a" : timezone
                                }}</span>
                            </div>
                          </div>
                        </ng-container>
                        <div class="chat-bubble ps-1 d-flex  align-items-center " *ngIf="socket.supportTyping">
                          <p>{{socket.support_type_name}}</p>
                        </div>
                      </ng-container>
                      <ng-template #noChats>
                        <h5 class="no-email">No Active Chat Thread Found.</h5>
                      </ng-template>
                      <div class="send-notification--card">
                        <button class="btn btn-success"
                          (click)="sendNotificationModal.show(); message_type = notification_type == 2 ? 3 : 2;">
                          Send Notification
                        </button>
                      </div>
                      <div *ngIf="userReply && userReply.length > 0" class="text-center">
                        <div class="mb-4">
                          <p>{{ userReply }}</p>
                        </div>
                      </div>
                      <div *ngIf="ticket_status == 2" class="col-12 text-center p-2 m-0 mb-3">
                        <p>Chat is closed for the ticket</p>
                        <button class="btn btn-green btn-restart-chat" (click)="assignToMe(2)">
                          Restart Chat
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </ng-container>
          </div>
        </div>
        <ng-template #noChatFound>
          <p class="no-chat mt-5">No Chat Found</p>
        </ng-template>
      </div>
      <div class="col-md-6 p-0">
        <ng-container>
          <div class="support-chat--right">
            <div class="user_tabs back-white border-radius my-3 px-2">
              <div class="d-flex align-items-center justify-content-between">
                <h4 class="fs-16 fw-500 mb-3">User Details</h4>
                  <p class="anchor-tag">
                    <span class="fs-14 fw-500" (click)="changeAssigne.show();"> Change Assignee </span>
                  </p>
                </div>
                  <div *ngIf="this.userDetailsData">
                    <div class="personal-info--card">
                      <div class="header d-flex mt-3 mb-2 align-items-center justify-content-between">
                        <h4 class="right-heading mb-0">Personal Info</h4>
                        <p class="support--view" (click)="redirect()">
                          View Profile
                        </p>
                      </div>
                      <div class="body border-bottom">
                        <p class="mb-1 fs-15 fw-400">{{ this.userDetailsData?.practice_email }}</p>
                        <p class="fs-13 fw-400">
                          {{ this.userDetailsData?.practice_mobile_country_code }}
                          {{ this.userDetailsData?.practice_mobile }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!this.userDetailsData">
                    <p class="no-chat mt-5">No data found</p>
                  </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<div bsModal #genratePaymentLinkModal="bs-modal" [config]="{ ignoreBackdropClick: true }"
  class="modal fade new_modal modal-global--bg" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered customModal" *ngIf="active_chat">
    <div class="modal-content p-3">
      <div class="modal-header">
        <h4 class="modal-title pull-left">
          {{
          subPayLink
          ? "Subscription Payment Link"
          : boosterPayLink
          ? "Booster Payment Link"
          : "Payment
          Link"
          }}
        </h4>

        <button type="button" class="btn-close" (click)="paymentLinkModalHide()"></button>
      </div>
      <div class="modal-body all-unset col-temp">
        <div class="modal-body all-unset col-temp">
          <div class="row" *ngIf="!paymentLink">
            <div class="col" *ngIf="subPayLink">
              <label class="form-label">Subscription Type</label>
              <select class="form-control form-select" [(ngModel)]="selectedPaymentType" name="plan-status">
                <option *ngFor="let s of paymentTypeArray" [value]="s.id">
                  {{ s.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="row mt-4" *ngIf="!paymentLink">
            <div class="col">
              <label class="form-label">Mobile Number</label>
              <div class="mobile_input">
                <input type="text" class="form-control dial-input" mask="+00" [(ngModel)]="dial_code" />
                <input type="text" class="form-control" [(ngModel)]="phone_number" mask="0000000000"
                  placeholder="1234567890" />
              </div>
            </div>
            <div class="col">
              <label class="form-label">Email</label>
              <input type="email" class="form-control" [(ngModel)]="email" />
            </div>
          </div>
          <div class="row mt-4" *ngIf="!paymentLink">
            <div class="col">
              <label class="form-label">Send SMS</label>
              <input type="checkbox" name="" id="" class="ms-2" [(ngModel)]="sendSmsValue" [disabled]="!phone_number" />
            </div>
            <div class="col">
              <label class="form-label">Send Mail</label>
              <input type="checkbox" name="" id="" class="ms-2" [(ngModel)]="sendEmailValue" [disabled]="!email" />
            </div>
          </div>
          <div *ngIf="paymentLink" class="text-center">
            <div class="row">
              <div class="col">
                <div class="img-success">
                  <img src="assets/images/chatbot/success-img.png" alt="" />
                </div>
                <h4 class="mt-4">
                  {{
                  subPayLink
                  ? "Subscription Payment Link Created Successfully."
                  : boosterPayLink
                  ? "Booster Payment Link Created Successfully."
                  : "Payment Link Created Successfully"
                  }}
                </h4>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <p>
                  {{ paymentLink }}
                </p>
              </div>
            </div>
            <button (click)="copyText()" class="btn btn-primary btn-primary-copy">
              <img src="../../../../assets/images/chatbot/Copy.png" />Copy URL
            </button>
          </div>
        </div>
        <button class="btn btn-green btn-dark m-2" (click)="generatePaymentLink()" *ngIf="!paymentLink">
          Generate Payment Link
        </button>
      </div>
    </div>
  </div>
</div>

<div bsModal #previewImageMeModal="bs-modal" [config]="{ ignoreBackdropClick: true }"
  class="modal fade modal-global--bg" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content p-2">
      <form>
        <div class="modal-header pb-0">
          <p class="mb-0">Image Preview</p>
          <button type="button" class="close" (click)="previewImageMeModal.hide()">
            &times;
          </button>
        </div>
        <div class="modal-body modelMain">
          <img src="{{ preview_data[0]?.image }}" alt="" />
        </div>
      </form>
    </div>
  </div>
</div>

<div bsModal #updateTicket="bs-modal" [config]="{ ignoreBackdropClick: true }" class="modal fade new_modal modal-global--bg"
  tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-centered customModal">
    <div class="modal-content end-chat--confirmation">
      <form>
        <div class="modal-header pb-2" style="font-size: 22px">
          <p class="mb-1 heading">Confirm</p>
          <button type="button" class="close" (click)="updateTicket.hide()">
            &times;
          </button>
        </div>
        <div class="modal-body modelMain">
          <p class="main-paragraph">
            Do you want to mark ticket as {{ update_status }}?
          </p>
          <p class="col-notes mt-2">Add Notes</p>
          <textarea class="form-control" placeholder="Please add your note here" id="exampleFormControlTextarea1"
            rows="3" [(ngModel)]="note" name="requestNotes"></textarea>

          <div class="d-flex mt-3">
            <button class="btn btn-success mt-2 mb-2" (click)="updateTicketStatus(2)" [disabled]="note == ''">
              Confirm
            </button>
            <button class="btn btn-danger ms-2 mt-2 mb-2" (click)="updateTicket.hide()">
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div bsModal #sendNotificationModal="bs-modal" [config]="{ ignoreBackdropClick: true }" class="modal fade new_modal modal-global--bg"
  tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-centered customModal send-notification--modal">
    <div class="modal-content">
      <form>
        <div class="modal-header pb-2" style="font-size: 22px">
          <div>
            <p class="mb-1">Send Notification</p>
          </div>
          <button type="button" class="close" (click)="sendNotificationModal.hide(); message_type = 1;">
            &times;
          </button>
        </div>
        <div class="modal-body modelMain">
          <div class="d-flex align-items-center justify-content-between gap-3 mb-4">
            <div class="radio-wrapper">
              <div class="d-flex gap-3 mt-2">
                <label class="d-flex align-items-center cursor mb-2" for="one">
                  <span class="user-group-span">{{ static_message }}</span>
                </label>
                <input style="height: 30px; width: 26px" type="radio" [checked]="notification_type == 1"
                  name="notificationType1" (change)="setRedeemOption(1)" id="one" />
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between gap-5">
            <textarea class="form-control" placeholder="Enter message" id="two" rows="3" [(ngModel)]="dynamic_msg"
              name="requestNotes" [disabled]="notification_type == 1 || notification_type == 3"></textarea>
            <input style="height: 30px; width: 26px" type="radio" [checked]="notification_type == 2"
              name="notificationType1" (change)="setRedeemOption(2)" id="two" />
          </div>
          <div class="d-flex gap-3 mt-3">
            <button class="btn btn-danger ms-2 mt-2 mb-2" (click)="sendNotificationModal.hide(); message_type = 1;">
              Cancel
            </button>
            <button class="btn btn-success mt-2 mb-2" (click)="sendNotification()">
              Confirm
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" #ssnModal="bs-modal" class="modal fade modal-global--bg" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel" aria-hidden="true" [config]="{ ignoreBackdropClick: true }" bsModal>
  <div class="modal-dialog" *ngIf="ssnForm">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #edf1f2">
        <p class="modal-title" id="exampleModalLabel">View Complete SSN</p>
        <button type="button" class="btn-close" (click)="ssnModal.hide()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="ssnForm">
          <div class="form-group">
            <label>Password</label>
            <div class="input-group with-focus">
              <input class="form-control" id="exampleInputPassword1" [type]="show ? 'text' : 'password'" name="password"
                placeholder="Password" formControlName="password" required="" />
              <button class="password-icon far fa-eye" (click)="password()" type="button">
                {{ show ? "Show" : "Hide" }}
              </button>
            </div>
            <div class="error" *ngIf="
                ssnForm.controls['password'].hasError('required') &&
                (ssnForm.controls['password'].dirty ||
                  ssnForm.controls['password'].touched)
              ">
              This field is required
            </div>
          </div>
          <div>
            <label>Notes*</label>
            <textarea name="" id="" cols="30" rows="5" formControlName="notes"></textarea>
            <div class="error" *ngIf="
                ssnForm.controls['notes'].hasError('required') &&
                (ssnForm.controls['notes'].dirty ||
                  ssnForm.controls['notes'].touched)
              ">
              This field is required
            </div>
          </div>
        </form>
      </div>
      <hr />
      <div class="modal-footer2 m-3">
        <button class="btn btn-green btn-dark" (click)="showCompleteSSN()" [disabled]="ssnForm.invalid">
          Submit
        </button>
      </div>
    </div>
  </div>
</div>

<div bsModal #assignToMeModal="bs-modal" [config]="{ ignoreBackdropClick: true }"
  class="modal fade modal-global--bg" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-centered customModal">
    <div class="modal-content p-2">
      <form>
        <div class="modal-header pb-0">
          <p class="mb-0">Confirm</p>
          <button type="button" class="close" (click)="hideAssignModel(); ">
            &times;
          </button>
        </div>
        <div class="modal-body modelMain">
          <p class="mb-1">Do you want to assign this ticket to yourself?</p>
          <div class="btn-group gap-3 mt-4">
            <button class="btn btn-primary one mr-2" (click)="assignToMe(1)">
              Confirm
            </button>
            <button class="btn btn-primary two" (click)="hideAssignModel(); ">
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div bsModal #chatWithUserModal="bs-modal" [config]="{ ignoreBackdropClick: true }"
  class="modal fade modal-global--bg" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-centered customModal">
    <div class="modal-content p-2">
      <form>
        <div class="modal-header pb-0">
          <p class="mb-0">Confirm</p>
          <button type="button" class="close" (click)="chatWithUserModal.hide();">
            &times;
          </button>
        </div>
        <div class="modal-body modelMain">
          <p class="mb-1">Do you want to chat with this user?</p>
          <div class="btns">
            <button class="btn btn-primary one mr-2" (click)="chatWithUser();">
              Confirm
            </button>
            <button class="btn btn-primary two" (click)="chatWithUserModal.hide();">
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div bsModal #adminGroupChatDataModal="bs-modal" [config]="{ ignoreBackdropClick: true }"
  class="modal fade modal-global--bg" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-centered customModal">
    <div class="modal-content p-2">
      <form>
        <div class="modal-header pb-0">
          <p class="mb-0">{{adminGroupChatData.length}} Member{{adminGroupChatData.length > 1 ? 's': ''}}</p>
          <button type="button" class="close" (click)="adminGroupChatDataModal.hide();">
            &times;
          </button>
        </div>
        <div class="modal-body modelMain">
          <div class="d-flex justify-content-between mb-3">
            <p class="modal-body-admin mb-0">Name</p>
            <p class="modal-body-admin mb-0">Email</p>
          </div>
          <!-- <hr class="admin-hr"> -->
          <div class="d-flex justify-content-between mb-2" *ngFor="let admin of adminGroupChatData">
            <div class="chat-list-user-status2">
              <div [ngClass]="admin.online ? 'Online' :'Offline'"></div>
              <p class="mb-0">{{ admin.admin_name }}</p>
            </div>
            <p class="modal-body-admin-data mb-0">{{admin.admin_email}}</p>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div bsModal #changeAssigne="bs-modal" [config]="{ignoreBackdropClick:true}"
  class="modal fade modal-global--bg" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-centered customModal">
    <div class="modal-content">
      <form [formGroup]="changeAssigneeForm">
        <div class="modal-header pb-0">
          <div class="d-flex">
            <p class="mb-1">Ticket ID- </p>
            <p class="mb-0">{{ticket_id}}</p>
          </div>
          <button type="button" class="close"
            (click)="changeAssigne.hide();this.changeAssigneeForm.reset();">&times;</button>
        </div>
        <div class="modal-body modelMain">
          <div class="form-group mb-3">
            <p class="col-notes mt-2 mb-2">Support Agent</p>
            <p-dropdown [showClear]="true" [options]="socket.agent_list" formControlName="agent_id"
              placeholder="Support Agent">
            </p-dropdown>
          </div>

          <p class="col-notes mt-2">Add Notes</p>
          <textarea class="form-control" placeholder="Please add your note here" id="exampleFormControlTextarea1"
            rows="3" formControlName="notes" name="requestNotes"></textarea>
          <div class="d-flex">
            <button class="btn succesBtn mt-2 mb-2"
              (click)="updateTicketStatusV2(4, changeAssigneeForm.controls['agent_id'].value)"
              [disabled]="changeAssigneeForm.controls['notes'].value == ''">
              Confirm
            </button>
            <button class="btn btn-cancel ms-2 mt-2 mb-2"
              (click)="changeAssigne.hide(); this.changeAssigneeForm.reset();">
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>